import React from "react";
import { name, cvLink } from "../../data/Data";

function Navbar() {
  return (
    <nav
      className="navbar navbar-expand-md navbar-dark bg-dark fixed-top"
      id="navbar"
    >
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          <i className="fas fa-less-than"></i>
          &nbsp;{name}&nbsp;
          <i className="fas fa-greater-than"></i>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="/">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#skill">
                Skills
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#project">
                Project
              </a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link" href="/post">
                Blog
              </a>
            </li> */}

            <li className="nav-item">
              <a className="nav-link" href="#about">
                About me
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contact">
                Contact Me
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href={cvLink}
                target="_blank"
                rel="noreferrer"
              >
                View Resume <i className="fas fa-file-export"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
